import { parseApiError } from "../utils/apiError";
import { authFetch, API_BASE_URL } from "./client";

export interface AccountRoleResponse {
    id: number;
    name: string;
    level: number;
}

export interface AccountResponse {
    id: number;
    account_name: string;
    account_code: string;
    account_role_id: number;
    permission_level: number | null;
    password_status: "normal" | "locked" | "initial" | null;
    created_at: string | null;
    updated_at: string | null;
}

export interface AccountCreateRequest {
    account_name: string;
    account_code: string;
    account_role_id: number;
}

export interface AccountUpdateRequest {
    account_name: string;
    account_code: string;
    account_role_id: number;
}

export async function fetchAccounts(): Promise<AccountResponse[]> {
    const response = await authFetch(`${API_BASE_URL}/accounts`);
    if (!response.ok) {
        throw await parseApiError(response, "アカウント一覧の取得に失敗しました");
    }
    return response.json();
}

export async function fetchAccountRoles(): Promise<AccountRoleResponse[]> {
    const response = await authFetch(`${API_BASE_URL}/account-roles`);
    if (!response.ok) {
        throw await parseApiError(response, "権限一覧の取得に失敗しました");
    }
    return response.json();
}

export async function createAccount(data: AccountCreateRequest): Promise<AccountResponse> {
    const response = await authFetch(`${API_BASE_URL}/accounts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        throw await parseApiError(response, "アカウントの登録に失敗しました");
    }
    return response.json();
}

export async function resetAccountPassword(
    id: number,
): Promise<{ message: string }> {
    const response = await authFetch(`${API_BASE_URL}/accounts/${id}/reset-password`, {
        method: "POST",
    });
    if (!response.ok) {
        throw await parseApiError(response, "パスワードの初期化に失敗しました");
    }
    return response.json();
}

export async function updateAccount(
    id: number,
    data: AccountUpdateRequest,
): Promise<AccountResponse> {
    const response = await authFetch(`${API_BASE_URL}/accounts/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        throw await parseApiError(response, "アカウントの更新に失敗しました");
    }
    return response.json();
}
